import { heroPoints, images } from "../constants";
import { withImageFallback } from "../utils";
import {
  HeroBackground,
  HeroCatch,
  HeroContent,
  HeroCredit,
  HeroLogo,
  HeroModel,
  HeroOverlay,
  HeroPointBadge,
  HeroPointInner,
  HeroPointLabel,
  HeroPointNumber,
  HeroPointRing,
  HeroPoints,
  HeroPointValue,
  HeroRibbon,
  HeroSection,
} from "../styles";

export default function HeroSectionBlock() {
  return (
    <HeroSection>
      <HeroBackground src={images.heroBackground} alt="" aria-hidden="true" onError={withImageFallback(["/src/assets/images/bg_FV.png"])} />
      <HeroOverlay />
      <HeroContent>
        <HeroCatch>一括査定の面倒をゼロに。</HeroCatch>
        <HeroRibbon>ワンルーム特化売却サービス</HeroRibbon>
        <HeroLogo src={images.heroLogo} alt="SMAUL スマウル" onError={withImageFallback(["/src/assets/images/smaul_FV.png"])} />
      </HeroContent>

      <HeroModel src={images.heroModel} alt="" aria-hidden="true" onError={withImageFallback(["/src/assets/images/character_FV.png"])} />

      <HeroPoints>
        {heroPoints.map((point) => (
          <HeroPointBadge key={point.label.join("")} style={{ top: point.top }}>
            <HeroPointRing src={images.heroRing} alt="" aria-hidden="true" style={{ transform: `rotate(${point.ringRotate}deg)` }} />
            <HeroPointInner style={{ paddingTop: point.textTop }}>
              <HeroPointLabel style={{ letterSpacing: point.labelLetterSpacing }}>
                {point.label.map((line, lineIndex) => (
                  <span key={`${line}-${lineIndex}`}>
                    {line}
                    {lineIndex < point.label.length - 1 ? <br /> : null}
                  </span>
                ))}
              </HeroPointLabel>
              <HeroPointValue style={{ fontSize: point.valueSize }}>
                {point.valueNumber ? <HeroPointNumber>{point.valueNumber}</HeroPointNumber> : null}
                {point.value}
              </HeroPointValue>
            </HeroPointInner>
          </HeroPointBadge>
        ))}
      </HeroPoints>

      <HeroCredit>
        イメージキャラクター
        <br />
        宇垣美里
      </HeroCredit>
    </HeroSection>
  );
}
